import Home from "@/pages/Home.vue";
import About from "@/pages/About.vue";

const routes = [
  {
    path: "/",
    component: Home,
    name: "home",
    meta: {
      title: "Forsiden - NVE Seriekart"
    }
  },
  {
    path: "/om",
    component: About,
    name: "about",
    meta: {
      title: "Om - NVE Seriekart"
    }
  }
];

export default routes;
